/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { addGroupPayoutConfig } from '@pages/PayoutPage/config/addGroup.config';
import { ADD_USER_GROUP } from '@pages/PayoutPage/apis/graphql';
import { notificationsPayoutConfig } from '../../config/notifications.config';
import { Graphql } from '@common/graphql';
import { apiConfig } from '@pages/PayoutPage/config/api.config';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';

import { toHeaderCase } from 'js-convert-case';
import moment from 'moment';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(AppNavigatorService.name);
};

export interface IAddGroupMethodsProps {
  name: string;
  description: string;
}

export interface IAddGroupMethods extends IPluginMethodMap {
  getAddGroupProps(args?: any): Promise<any>;
}

export class AddGroupPlugin implements IAgentPlugin {
  readonly methods: IAddGroupMethods;

  constructor() {
    this.methods = {
      getAddGroupProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IAddGroupMethodsProps) {
    //return await this.getAddGroup(args);
    return { ...addGroupPayoutConfig };
  }

  private async getAddGroup(args: any) {
    try {
      let gql = Graphql.withBaseUrl(apiConfig.spacex_gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .query(ADD_USER_GROUP, {
          input: {
            ...args,
          },
        })
        .toPromise();
      if (res?.data) {
        return {
          ...res?.data?.addUserGroup,
          notification: notificationsPayoutConfig?.addGroupSuccess,
        };
      }
    } catch (err: any) {
      throw err;
    }
  }
}
